import styles from './ActivitySettings.module.css';
import { MdDeleteOutline } from 'react-icons/md';
import ToggleSwitch from '../ToggleSwitch/ToggleSwitch';
import CheckboxAndData from '../CheckboxAndData/CheckboxAndData';
import { useState } from 'react';

export default function ActivitySettings({ activity }) {
  const enableOptions = [
    'Enable File Upload',
    'Enable Video / Photo upload',
    'Enable comments',
    'Enable draft mode',
    'Enable draft mode',
  ];

  const [activityStatus, setActivityStatus] = useState(false);
  const [notifyParents, setNotifyParents] = useState(false);
  const [enableStatus, setEnableStatus] = useState(
    enableOptions.map((label) => ({ label, isChecked: false }))
  );

  const handleEnableStatusChange = (index) => {
    const updated = [...enableStatus];
    updated[index].isChecked = !updated[index].isChecked;
    setEnableStatus(updated);
  };

  return (
    <div className={styles.container}>
      {/* Header */}
      <div className={styles.header}>
        <div className={styles.iconLabel}>
          <span className={styles.icon}>{activity.icon}</span>
          <span className={styles.label}>{activity.label}</span>
        </div>
        <MdDeleteOutline
          className={styles.deleteIcon}
          onClick={() => alert('Delete Clicked')}
        />
      </div>

      {/* Body */}
      <div className={styles.bodySectionContainer}>
        {/* Activity Status */}
        <div className={styles.section}>
          <span className={styles.sectionLabel}>Activity Status</span>
          <div className={styles.sectionContents}>
            <ToggleSwitch
              checked={activityStatus}
              onChange={(value) => setActivityStatus(value)}
              onLabel="Active"
              offLabel="Inactive"
              height={20}
            />
          </div>
        </div>

        {/* Notify Parents */}
        <div className={styles.section}>
          <span className={styles.sectionLabel}>Notify Parents</span>
          <div className={styles.sectionContents}>
            <ToggleSwitch
              labelColor="var(--Grey_Color)"
              checked={notifyParents}
              onChange={(value) => setNotifyParents(value)}
              onLabel="Enabled"
              offLabel="Disabled"
              height={20}
            />
          </div>
        </div>

        {/* Enable Status */}
        <div className={styles.section}>
          <span className={styles.sectionLabel}>Enable Status</span>
          <div className={styles.sectionContents}>
            <div className={styles.enableStatusleftColumn}>
              {enableStatus.map((item, index) => (
                <CheckboxAndData
                  key={index}
                  label={item.label}
                  checked={item.isChecked}
                  checkboxSize={16}
                  labelSize={16}
                  labelColor="var(--Grey_Color)"
                  onChange={() => handleEnableStatusChange(index)}
                />
              ))}
            </div>
          </div>
        </div>
        <div className={styles.section}>
          <span className={styles.sectionLabel}>Form Fields</span>
          <div className={styles.sectionContents}>
            <p className={styles.sectionParagraph}>
              Each activity will contain description and file upload fields as
              default
            </p>
            <div className={styles.enableStatusleftColumn}>
              {/* Add the Form fields here  */}
              {/* Add the Form fields here  */}
              {/* Add the Form fields here  */}
              {/* Add the Form fields here  */}
              {/* Add the Form fields here  */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
